import { AppEnvs } from 'enums';

export default (nielsenTrackingData, moreCustomMetadata = {}, env = AppEnvs.prod) => ({
    APP_MEASUREMENT: {
        RSID: 'wdgesp360,wdgespge',
        TRACKING_SERVER: 'w88.espn.com'
    },
    ESPN_CUSTOM_METADATA: { ...nielsenTrackingData, ...moreCustomMetadata },
    HEARTBEAT: {
        DEBUG_LOGGING: false
    },
    NIELSEN_DATA: {
        APP_INFO: {
            apid: (env === AppEnvs.prod) ? 'P31187EE2-AC6E-46CB-BB54-D07591BED067' : 'T31187EE2-AC6E-46CB-BB54-D07591BED067',
            sfcode: (env === AppEnvs.prod) ? 'dcr' : 'dcr-cert'
        },
        CONTENT_METADATA: {
            SegC: nielsenTrackingData.SegC,
            isfullepisode: nielsenTrackingData.isfullepisode
        }
    }
});



// WEBPACK FOOTER //
// ./app/player/util/getAdobeDCRConfig.js